import { render } from "./TrashCan.vue?vue&type=template&id=9aaf2fee&scoped=true"
import script from "./TrashCan.vue?vue&type=script&lang=js"
export * from "./TrashCan.vue?vue&type=script&lang=js"

import "./TrashCan.vue?vue&type=style&index=0&id=9aaf2fee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aaf2fee"]])

export default __exports__